import ReactCrop from "react-image-crop";

export default ReactCrop;
